export const MenuItems = [
  {
    label: "Dashboard",
    icon: "pi pi-home",
    items: [
      {
        label: "Home",
        icon: "pi pi-fw pi-home",
        routerLink: ["/"],
        dataTour: "home",
      },
      {
        label: "Appointments",
        icon: "pi pi-fw pi-calendar",
        routerLink: ["/appointments"],
        dataTour: "appointments",
      },
      {
        label: "Documents",
        icon: "pi pi-fw pi-file",
        routerLink: ["/documents"],
        dataTour: "documents",
        badge: "pending-docs",
      },
      {
        label: "Billing & Payments",
        icon: "pi pi-fw pi-credit-card",
        routerLink: ["/billing"],
        dataTour: "billing",
      },
      {
        label: "Insurance",
        icon: "pi pi-fw pi-shield",
        routerLink: ["/insurance"],
        dataTour: "insurance",
      },
      {
        label: "Personal Information",
        icon: "pi pi-fw pi-user",
        routerLink: ["/personal-info"],
        dataTour: "personal-info",
      },
      //   {
      //     label: "Messages",
      //     icon: "pi pi-fw pi-comment",
      //     routerLink: ["/messages"],
      //   },
    ],
  },
];
